<template>
  <!-- PAGE CONTENT BEGINS -->
  <div style="background: #ffffff;">
    <el-container>
      <el-main>
        <div style="height: 100%;width: 100%;">
          <div class="box">
            <el-form ref="form" :inline="true" label-width="100px" size="small">

              <el-form-item>
                <el-input v-model="queryCouponOrder.iccid" placeholder="请输入ICCID" />
              </el-form-item>
              <el-form-item>
                <el-input v-model="queryCouponOrder.couponId" placeholder="请输入优惠券ID" />
              </el-form-item>
              <el-form-item>
                <el-select v-model="queryCouponOrder.state" placeholder="状态">
                  <el-option :value="0" label="待使用"></el-option>
                  <el-option :value="1" label="已核销"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div>
              <el-button size="small" @click="list(1)" type="primary" icon="el-icon-search">搜索</el-button>
              <el-button size="small" @click="download" type="success" icon="el-icon-download">导出</el-button>
            </div>
          </div>
          <el-table class="q-mt-lg" ref="tableData" :data="tableData" :row-style="{height:'40px',textAlign:'center'}" :cell-style="{height:'5px,0',textAlign:'center'}" :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" border :max-height="maxHeight">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="couponId" label="优惠券ID" width="200">
            </el-table-column>
            <el-table-column prop="couponPrice" label="优惠金额" width="200">
            </el-table-column>
            <el-table-column prop="iccid" label="ICCID" width="300">
            </el-table-column>
            <el-table-column align="center" prop="state" label="状态">
              <template slot-scope="{row}">
                <span v-if="row.state==='0'">待使用</span>
                <span v-if="row.state==='1'">已核销</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200">
            </el-table-column>
            <el-table-column prop="startTime" label="生效时间" width="200">
            </el-table-column>
            <el-table-column prop="endTime" label="到期时间" width="200">
            </el-table-column>
            <el-table-column prop="usedTime" label="使用时间" width="200">
            </el-table-column>
            <el-table-column prop="orderPrice" label="满减金额" width="200">
            </el-table-column>
          </el-table>

          <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>
          <!--</div>-->
        </div>

      </el-main>
    </el-container>




  </div>

</template>

<script>
import Pagination from '../../../components/pagination'
import tools from '../../../utils/tools'

export default {
  name: 'couponOrder',
  components: { Pagination },
  mounted: function () {
    let _this = this
    _this.queryRoles()
    _this.$refs.pagination.size = 10
  },
  data() {
    return {
      couponjs: require('../../../api/coupon'),
      maxHeight: 500,
      tableData:[],
      queryCouponOrder:{
        current: 1,
        size: 10,
        iccid:'',
        couponId:'',
        state:''
      }
    }
  },
  mounted() {
    this.list(0)
  },
  methods: {
    list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      _this.queryCouponOrder.current=page
      _this.queryCouponOrder.size=_this.$refs.pagination.size
      _this.couponjs.couponOrderList( _this.queryCouponOrder).then(res => {
                if(res.data.code==='0'){
                  let data = res.data.data
                  _this.tableData = data.rows
                  _this.$refs.pagination.render(page,data.total)
                }
              })
    },
    download() {
      let _this = this
      window.location.href = process.env.VUE_APP_SERVER + '/system/couponOrder/downloadfile?iccid=' + _this.iccid + '&couponId=' + _this.couponId + '&state=' + _this.state
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
/deep/.el-table td,
.el-table th {
  padding: 0px;
}
</style>
<style lang="less">
.el-table td,
.el-table th {
  padding: 0px !important;
}
thead.has-gutter {
  height: 40px;
}
</style>
